const uniqueList = (ps: any[], key = 'id') => {
  const ids = ps.map((p) => p[key]); // @ts-ignore
  const uniqueIds = [...new Set(ids)];
  return uniqueIds.map((i) => ps.find((p) => p[key] === i));
};

export default uniqueList;
